import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import Bind from 'lodash-decorators/bind';

import messages from './Form.intl';
import styles from './Form.module.scss';

import ApiService from 'services/Api.service';
import UrlHistoryTrackerStore from 'stores/UrlHistoryTracker.store';
// restore below when privacy policy agreement is required
// import { CONTACT } from 'common/consts/common';
import SendButton, { BUTTON_STATE } from '../SendButton/SendButton';

const RESULT_MESSAGE_TYPE = {
  SUCCESS: 'success',
  ERROR: 'error'
};

const SUCCESS_MESSAGE_TIMEOUT = 2000;

@injectIntl
export default class Form extends Component {
  state = {
    name: '',
    company: '',
    email: '',
    dataProcessingCheckbox: false,
    resultMessage: null,
    buttonState: '',
    formChanged: false
  };

  dataProcessingCheckmarkRef = React.createRef();
  // restore below when privacy policy agreement is required
  // dataProcessingCheckboxRef = React.createRef();

  @Bind()
  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    if (target.name === 'dataProcessingCheckbox' && target.checked) {
      this.dataProcessingCheckmarkRef.current.className = styles.Checkmark;
    }

    // restore below when privacy policy agreement is required
    // if (this.dataProcessingCheckboxRef.current.checked) {
    //   this.setState({
    //     resultMessage: null
    //   });
    // }

    this.setState({
      [name]: value,
      formChanged: true
    });
  }

  @Bind()
  async handleFormSubmit(event) {
    event.preventDefault();
    // cancel below when privacy policy agreement is required
    const {
      state: { name, company, email },
      props: { person }
    } = this;

    // restore below when privacy policy agreement is required
    // const {
    //   state: { name, company, email, dataProcessingCheckbox },
    //   props: { person, intl }
    // } = this;

    // if (!dataProcessingCheckbox) {
    //   this.dataProcessingCheckmarkRef.current.className += ` ${
    //     styles.CheckboxInfoWarning
    //   }`;
    //
    //   !dataProcessingCheckbox
    //     ? this.setResultMessage({
    //         type: RESULT_MESSAGE_TYPE.ERROR,
    //         message: intl.formatMessage(messages.messageNoCheckboxes)
    //       })
    //     : this.setResultMessage({
    //         type: RESULT_MESSAGE_TYPE.ERROR,
    //         message: intl.formatMessage(messages.messageNoCheckbox)
    //       });
    //
    //   return;
    // }

    this.setState({
      buttonState: BUTTON_STATE.LOADING
    });

    try {
      const to = person && person.codeName;
      const checkReferrer =
        UrlHistoryTrackerStore.previousURL === null
          ? 'no previous URL'
          : UrlHistoryTrackerStore.previousURL;
      await ApiService.sendContactForm({
        name,
        company,
        email,
        source: UrlHistoryTrackerStore.referrerURL,
        url: UrlHistoryTrackerStore.currentURL,
        referrer: checkReferrer,
        to
      });

      this.setState({
        buttonState: BUTTON_STATE.SUCCESS
      });

      setTimeout(() => {
        this.resetState();
      }, SUCCESS_MESSAGE_TIMEOUT);
    } catch (e) {
      this.setState({
        buttonState: BUTTON_STATE.ERROR
      });
    }
  }

  setResultMessage({ type, message }) {
    this.setState({
      resultMessage: {
        type,
        message
      }
    });
  }

  resetState() {
    this.setState({
      name: '',
      company: '',
      email: '',
      dataProcessingCheckbox: false,
      resultMessage: null,
      buttonState: ''
    });
  }

  render() {
    const {
      props: { formRef },
      state: { resultMessage, buttonState }
    } = this;

    return (
      <form
        onSubmit={this.handleFormSubmit}
        className={styles.Form}
        ref={formRef}
      >
        <div className={styles.InputFieldBox}>
          <span className={styles.FormLabel}>
            {this.props.intl.formatMessage(messages.contactForm)}
          </span>

          <input
            type="text"
            name="name"
            value={this.state.name}
            placeholder={this.props.intl.formatMessage(messages.name)}
            autoComplete="name"
            required
            onChange={this.handleInputChange}
            className={styles.TextInput}
          />
          <input
            type="text"
            name="company"
            value={this.state.company}
            placeholder={this.props.intl.formatMessage(messages.company)}
            autoComplete="organisation"
            onChange={this.handleInputChange}
            className={styles.TextInput}
          />
          <input
            type="email"
            name="email"
            value={this.state.email}
            placeholder={this.props.intl.formatMessage(messages.email)}
            autoComplete="email"
            required
            onChange={this.handleInputChange}
            className={styles.TextInput}
          />
          {/*restore below when privacy policy agreement is required*/}

          {/*<div*/}
          {/*  className={`${styles.CheckboxWrapper} ${*/}
          {/*    this.state.formChanged ? styles.Visible : ''*/}
          {/*  }`}*/}
          {/*>*/}
          {/*  <label className={styles.CheckboxLabel}>*/}
          {/*    <input*/}
          {/*      type="checkbox"*/}
          {/*      name="dataProcessingCheckbox"*/}
          {/*      ref={this.dataProcessingCheckboxRef}*/}
          {/*      checked={this.state.dataProcessingCheckbox}*/}
          {/*      onChange={this.handleInputChange}*/}
          {/*      className={styles.Checkbox}*/}
          {/*    />*/}
          {/*    <span*/}
          {/*      ref={this.dataProcessingCheckmarkRef}*/}
          {/*      className={styles.Checkmark}*/}
          {/*    />*/}
          {/*    <span*/}
          {/*      className={styles.CheckboxInfo}*/}
          {/*      dangerouslySetInnerHTML={{*/}
          {/*        __html: this.props.intl.formatMessage(*/}
          {/*          messages.dataProcessingAgreement,*/}
          {/*          {*/}
          {/*            mail: CONTACT.GENERAL*/}
          {/*          }*/}
          {/*        )*/}
          {/*      }}*/}
          {/*    />*/}
          {/*  </label>*/}
          {/*</div>*/}

          {resultMessage && (
            <p
              className={`
            ${styles.ResultMessage}
            ${
              resultMessage.type === RESULT_MESSAGE_TYPE.ERROR
                ? styles.ResultMessageError
                : ''
            }
            `}
            >
              {resultMessage.message}
            </p>
          )}

          <SendButton
            buttonState={buttonState}
            successMessage={this.props.intl.formatMessage(
              messages.buttonMessageSuccess
            )}
            errorMessage={this.props.intl.formatMessage(
              messages.buttonMessageError
            )}
            loadingMessage={this.props.intl.formatMessage(
              messages.buttonMessageLoading
            )}
            message={this.props.intl.formatMessage(messages.submitButton)}
            className={styles.SubmitButton}
          />
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Contact/Components/Form/Form.js